import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterV6 as withRouter } from '../../../helpers/withRouterV6.jsx';
import {
  getCountryName,
  getEntityOption,
  getOrganizationOption
} from '../../../helpers/entityOptionHelper';

import get from 'lodash.get';

import { Record } from '../../../modules/bin/utility';

import * as templateBuilderActions from '../../../modules/template-builder-ex';
import * as programActions from '../store/vipProgramActions';

import TemplateBuilderContainerEx from '../../../components/template/builder/indexEx';
import { getSetupTab } from './templateTabs/setup';
import { getApplicationQuestionsTab } from './templateTabs/applicationQuestions';
import { getVipPlacesTab } from './templateTabs/vipPlaces';
import { getFundraisingGuaranteeTab } from './templateTabs/fundraisingGuarantee';
import { getRegistrationFeeTab } from './templateTabs/registrationFee';
import { reset, searchEntities } from '../../../modules/autocomplete';

import { TARGET_VALIDATION } from '../../../constants/validationModels';
import { paths } from './constants/template';
import config from '../../../constants';
import {
  getEventProgramMinimumTarget,
  isOrganizationCurrencyConfigured,
  normaliseCurrency
} from '../helpers/currencyTargets';
import { isFeatureOffered, programFeature } from '../helpers/featureCountries';

class ProgramTemplateView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddressHidden: true,
      isPhoneHidden: true,
      isCountryAllowed: true,
      availableSeats: this.props.availableSeats,
    };

    this.required = {
      required: true
    };

    this.target = {
      required: false,
      ...TARGET_VALIDATION
    };

    this.optional = {
      required: false
    };

    this.dateValidation = {
      required: false,
      date: true
    };

    this.notFalse = {
      notFalse: true
    };

    this.formBuilderQuestionsValidation = {
      formbuilderQuestionsMaxLength: true,
      length: config.FORMBUILDER_QUESTIONS_MAX_LENGTH,
      formBuilderQuestions: true
    };
  }

  onChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(path, value);
  };

  componentDidUpdate(prevProps) {
    // If event ambassador program changes and donation plan is not enabled,
    // ensure our local donation plan is disabled
    if (
      prevProps.eventAmbassadorProgramDonationPlanEnabled !== this.props.eventAmbassadorProgramDonationPlanEnabled &&
      !this.props.eventAmbassadorProgramDonationPlanEnabled
    ) {
      this.props.templateBuilderActions.setResultValue('donationPlan.enabled', false);
    }

    if (
      prevProps.eventRegistrationFeeEnabled !== this.props.eventRegistrationFeeEnabled &&
      !this.props.eventRegistrationFeeEnabled
    ) {
      this.props.templateBuilderActions.setResultValue(paths.REGISTRATION_FEE_ENABLED, false);
    }

    // The full event program record can arrive after the charity was picked.
    const programChanged =
      get(prevProps.eventAmbassadorProgram, 'id') !== get(this.props.eventAmbassadorProgram, 'id') ||
      get(prevProps.eventAmbassadorProgram, 'currencyTargets') !== get(this.props.eventAmbassadorProgram, 'currencyTargets');
    if (programChanged && this.props.selectedOrganizationCurrency) {
      this.setOrganizationCurrencyConfigured(this.props.selectedOrganizationCurrency);
    }
  }

  getSelectedEventAmbassadorProgram = () => {
    const fromCampaignProgram = get(
      this.props.campaignAmbassadorProgramRecord,
      'data.data.eventAmbassadorProgram'
    );
    if (fromCampaignProgram) {
      return fromCampaignProgram;
    }

    const record = this.props.eventAmbassadorProgram;
    if (record && record.id && record.id === this.props.eventAmbassadorProgramId) {
      return record;
    }

    return this.props.selectedEventAmbassadorProgram || record;
  };

  setOrganizationCurrencyConfigured = (currency) => {
    const configured = isOrganizationCurrencyConfigured(
      this.getSelectedEventAmbassadorProgram(),
      currency
    );
    this.props.templateBuilderActions.setResultValue(
      paths.ORGANIZATION_CURRENCY_CONFIGURED,
      configured
    );
  };

  onChangeAvailableSeats = (newAvailableSeats) => {
    this.setState({
      ...this.state,
      availableSeats: newAvailableSeats,
    })
  }

  getEventAmbassadorProgramRequest = () => {
    return {
      page: 1,
      pageSize: 75,
      resultType: 'Full',
      baseObjectsOnly: true,
      orderBy: {
        key: 'name',
        direction: 'asc'
      },
      filters: [],
      includeDataTemplate: true
    };
  };

  onEventAmbassadorProgramChange = (path, value, item) => {
    if (item) {
      this.props.resetAutocomlite(paths.ORGANIZATION_ID);
      this.props.templateBuilderActions.showControl(paths.ORGANIZATION_ID);
      this.props.templateBuilderActions.setResultValue(
        paths.ORGANIZATION_ID,
        null
      );
      this.props.templateBuilderActions.setResultValue('eventId', item.eventId);
      this.props.templateBuilderActions.setResultValue('event', item);
      this.props.templateBuilderActions.setResultValue(
        paths.ORGANIZATION_CURRENCY_CONFIGURED,
        null
      );
      this.props.templateBuilderActions.setResultValue(
        paths.SELECTED_ORGANIZATION_CURRENCY,
        null
      );
      // Search results are base objects, so load the full program for the
      // per-currency minimum targets.
      this.props.programActions.getEventAmbassadorProgramByEventRecord(item.eventId);
      this.props.searchEntities(
        'page/campaign',
        paths.ORGANIZATION_ID,
        this.getOrganizationRequest(item.eventId)
      );
    }
    // `.../vip-program/{id}/add-organization/setup` seems to be the only place this is triggered. Just in case
    // commenting the below out instead of deleting so we can review the changes later.
    // else {
    //     this.props.templateBuilderActions.hideControl(paths.ORGANIZATION_ID);
    // }

    this.props.templateBuilderActions.setResultValue(path, value);
  };

  getEventAmbassadorProgramItem = (item) =>
    getEntityOption(item, {
      text: `${item.event?.name || 'N/A'} - ${item.name}`
    });

  getOrganizationRequest = (id) => {
    const paramsEventId = get(this.props, 'match.params.eventId');
    const eventId = get(this.props, 'eventId');

    return {
      page: 1,
      pageSize: 75,
      resultType: 'Full',
      baseObjectsOnly: true,
      orderBy: {
        key: 'name',
        direction: 'asc'
      },
      filters: [
        {
          key: 'eventId',
          operator: 'EqualTo',
          value: id || eventId || paramsEventId
        }
      ]
    };
  };

  onOrganizationChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(path, value);

    // The list behind this dropdown is the event's campaign pages, one per
    // charity, so the currency is the campaign's organisation currency.
    const currency = item
      ? normaliseCurrency(get(item, 'organization.currency') || item.currency)
      : null;
    this.props.templateBuilderActions.setResultValue(
      paths.SELECTED_ORGANIZATION_CURRENCY,
      currency
    );

    if (item) {
      this.setOrganizationCurrencyConfigured(currency);
    } else {
      this.props.templateBuilderActions.setResultValue(
        paths.ORGANIZATION_CURRENCY_CONFIGURED,
        null
      );
    }
  };

  getOrganizationItem = (item) => {
    if (item.organization) {
      return getOrganizationOption(item.organization, {
        subtext: getCountryName(item.organization.country || item.country)
      });
    }
  };

  render() {
    const urlLink = get(
      this.props.campaignAmbassadorProgramRecord,
      'data.data.urlFull'
    );

    const campaignAmbassadorProgram = get(this.props.campaignAmbassadorProgramRecord, "data.data");
    const eventAmbassadorProgram = this.getSelectedEventAmbassadorProgram() || {};

    // Editing reads the API's resolution for the saved charity. Adding a charity
    // resolves the same way on the client from the picked charity's currency.
    const minimumTargetCurrency =
      get(campaignAmbassadorProgram, "fundraiserMinimumTargetCurrency") ||
      get(campaignAmbassadorProgram, "organization.currency") ||
      this.props.selectedOrganizationCurrency;
    const inheritedMinimumTargetAmount = campaignAmbassadorProgram
      ? get(campaignAmbassadorProgram, "inheritedFundraiserMinimumTargetAmount")
      : getEventProgramMinimumTarget(eventAmbassadorProgram, minimumTargetCurrency);
    const effectiveMinimumTargetAmount = campaignAmbassadorProgram
      ? get(campaignAmbassadorProgram, "effectiveFundraiserMinimumTargetAmount")
      : inheritedMinimumTargetAmount;

    const setupTab = getSetupTab({
      onChange: this.onChange,
      required: this.required,
      target: this.target,
      optional: this.optional,
      dateValidation: this.dateValidation,
      getEventAmbassadorProgramRequest: this.getEventAmbassadorProgramRequest,
      getEventAmbassadorProgramItem: this.getEventAmbassadorProgramItem,
      onEventAmbassadorProgramChange: this.onEventAmbassadorProgramChange,
      getOrganizationRequest: this.getOrganizationRequest,
      onOrganizationChange: this.onOrganizationChange,
      getOrganizationItem: this.getOrganizationItem,
      urlLink: urlLink,
      inheritedMinimumTargetAmount: inheritedMinimumTargetAmount,
      effectiveMinimumTargetAmount: effectiveMinimumTargetAmount,
      minimumTargetCurrency: minimumTargetCurrency,
      organizationCurrencyConfigured: this.props.organizationCurrencyConfigured,
      selectedOrganizationCurrency: this.props.selectedOrganizationCurrency,
      notFalse: this.notFalse,
      eventApplicationsOpenDate: get(eventAmbassadorProgram, "startsAt"),
      eventDefaultAmbassadorStatus: get(eventAmbassadorProgram, "defaultAmbassadorStatus"),
      eventAmbassadorProgramFundraisingDeadlineDate: get(eventAmbassadorProgram, "fundraiseBy"),
      organizationCountry: get(campaignAmbassadorProgram, "organization.country"),
      eventAmbassadorProgram: eventAmbassadorProgram,
      isSysAdmin: this.props.isSystemAdmin,
    });
    const applciationQuestionsTab = getApplicationQuestionsTab({
      onChange: this.onChange,
      formBuilderQuestionsValidation: this.formBuilderQuestionsValidation,
      isAddressHidden: this.state.isAddressHidden,
      isPhoneHidden: this.state.isPhoneHidden,
      isCountryAllowed: this.state.isCountryAllowed
    });
    const vipPlacesTab = getVipPlacesTab({
      availableSeats: this.state.availableSeats,
      campaignAmbassadorProgramRecordId: get(this.props.campaignAmbassadorProgramRecord, "data.data.id"),
      isUpdateAvailableSeatsLoading: this.props.isUpdateAvailableSeatsLoading,
      onChangeAvailableSeats: this.onChangeAvailableSeats,
      onUpdateAvailableSeats: this.props.programActions.updateProgramSeats,
    });
    const fundraisingGuaranteeTab = getFundraisingGuaranteeTab({
      onChange: this.onChange,
      agreementEnabled: this.props.isDonationPlanAgreementEnabled,
      optional: this.optional,
      required: this.required,
    });

    const registrationFeeTab = getRegistrationFeeTab({
      onChange: this.onChange,
      feeEnabled: this.props.isRegistrationFeeEnabled,
      currency: get(campaignAmbassadorProgram, 'registrationFee.currency') || this.props.selectedOrganizationCurrency,
      optional: this.optional,
      required: this.required,
    });

    // Each tab shows only when the event program offers the feature to this charity's country.
    const organizationCountry = get(campaignAmbassadorProgram, 'organization.country');
    const shouldShowFundraisingGuaranteeTab = isFeatureOffered(
      eventAmbassadorProgram,
      programFeature.fundraisingGuarantee,
      organizationCountry
    );
    const shouldShowRegistrationFeeTab = isFeatureOffered(
      eventAmbassadorProgram,
      programFeature.registrationFee,
      organizationCountry
    );

    return (
      <TemplateBuilderContainerEx
        onSave={this.props.onSave}
        showCancelButton
        onCancel={this.props.onCancel}
        isLoading={this.props.isLoading}
      >
        {setupTab}
        {applciationQuestionsTab}
        {this.props.isSystemAdmin && vipPlacesTab}
        {shouldShowFundraisingGuaranteeTab && fundraisingGuaranteeTab}
        {shouldShowRegistrationFeeTab && registrationFeeTab}
      </TemplateBuilderContainerEx>
    );
  }
}

const mapState = ({ program, templateBuilderEx, session }) => {
  return {
    eventAmbassadorProgram: get(program, 'eventAmbassadorProgramRecord.data.data', {}),
    campaignAmbassadorProgramRecord: program.campaignAmbassadorProgramRecord,
    organizationId: templateBuilderEx.data.organizationId,
    eventId: templateBuilderEx.data.eventId,
    eventAmbassadorProgramId: templateBuilderEx.data.eventAmbassadorProgramId,
    selectedEventAmbassadorProgram: templateBuilderEx.data.event,
    organizationCurrencyConfigured: templateBuilderEx.data.organizationCurrencyConfigured,
    selectedOrganizationCurrency: templateBuilderEx.data.selectedOrganizationCurrency,
    availableSeats: templateBuilderEx.data.metrics?.availableCount || null,
    isUpdateAvailableSeatsLoading: Record.isRecordLoading(program.editProgramSeats),
    isSystemAdmin: get(session, 'isSystemAdmin'),
    // Add access to the donation plan enabled state
    isDonationPlanEnabled: get(templateBuilderEx, 'data.donationPlan.enabled', false),
    isDonationPlanAgreementEnabled: get(templateBuilderEx, 'data.donationPlan.template.value.agreement.enabled', false),
    eventAmbassadorProgramDonationPlanEnabled: get(program.campaignAmbassadorProgramRecord, 'data.data.eventAmbassadorProgram.donationPlan.enabled', false),
    isRegistrationFeeEnabled: get(templateBuilderEx, 'data.registrationFee.enabled', false),
    eventRegistrationFeeEnabled: get(
      program.campaignAmbassadorProgramRecord,
      'data.data.eventAmbassadorProgram.registrationFee.enabled',
      get(templateBuilderEx, 'data.event.registrationFee.enabled', false)
    ),
  };
};

const mapDispatch = (dispatch) => {
  return {
    programActions: bindActionCreators(programActions, dispatch),
    templateBuilderActions: bindActionCreators(
      templateBuilderActions,
      dispatch
    ),
    resetAutocomlite(path) {
      dispatch(reset(path));
    },
    searchEntities(entity, path, request) {
      dispatch(searchEntities(entity, path, request));
    }
  };
};

const ProgramTemplate = withRouter(
  connect(mapState, mapDispatch)(ProgramTemplateView)
);
export default ProgramTemplate;
